import React from "react";
import classes from "./testimonialCard.module.css";
import { FaStar } from "react-icons/fa";

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className={classes.card}>
      <h1 className={classes.name}>{testimonial?.name}</h1>
      <div className={classes.rating}>
        {[1, 2, 3, 4, 5].map((star) => (
          <FaStar key={star} className={classes.star} />
        ))}
      </div>

      <blockquote className={classes.quote}>
        <span className={classes.quoteSymbol}>&ldquo;</span>
        {testimonial?.review}
      </blockquote>
    </div>
  );
};

export default TestimonialCard;
